// src/utils/authFetch.js
export function getAuthToken() {
    return localStorage.getItem('authToken') || sessionStorage.getItem('authToken')
}

export function authHeaders() {
    const token = getAuthToken()
    return { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) }
}

export async function apiFetch(url, options = {}) {
    const res = await fetch(url, {
        ...options,
        headers: { ...authHeaders(), ...(options.headers || {}) },
    })
    if (res.status === 401) {
        sessionStorage.clear()
        localStorage.removeItem('authToken')
        window.location.href = '/login'
        throw new Error('Session expired')
    }
    return res
}